
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"23","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.059 18.158c.514 0 .919-.125 1.213-.375.294-.25.441-.585.441-1.004 0-.536-.21-1.046-.628-1.527-.42-.482-.86-.95-1.324-1.406-.235-.236-.42-.546-.551-.932a7 7 0 01-.298-1.252 21.53 21.53 0 01-.155-1.324c-.036-1.301-.193-2.463-.468-3.485-.276-1.022-.697-1.884-1.263-2.586-.566-.703-1.305-1.216-2.217-1.54a3.7 3.7 0 00-1.103-1.73c-.53-.471-1.18-.707-1.952-.707S9.329.526 8.796.996a3.681 3.681 0 00-1.109 1.732c-.911.323-1.65.836-2.216 1.539-.567.702-.988 1.564-1.263 2.586-.276 1.022-.432 2.184-.469 3.485-.044.434-.097.875-.16 1.324a6.71 6.71 0 01-.292 1.252c-.133.386-.316.696-.552.932-.463.456-.904.924-1.323 1.406-.42.481-.629.99-.629 1.527 0 .42.147.754.441 1.004.294.25.699.375 1.213.375H19.06zm-8.305 4.235c.595 0 1.132-.128 1.61-.386.478-.257.862-.599 1.152-1.025a2.87 2.87 0 00.502-1.38h-6.54c.044.494.211.953.502 1.38.29.426.674.768 1.152 1.025a3.364 3.364 0 001.622.386z","fill":"#F9FAFB"}})])
          )
        }
      }
    